import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useI18n } from '@shopify/react-i18n';
import {
	Button,
	Card,
	DisplayText,
	Heading,
	Icon,
	List,
	Stack,
	TextContainer,
} from '@shopify/polaris';
import { ArrowRightIcon, XIcon } from '@shopify/polaris-icons';
import {
	NumberCircleOneIcon,
	NumberCircleTwoIcon,
	NumberCircleThreeIcon,
} from '../../Icons';
import { useSessionStorage } from 'react-use';

const OnboardingSection = () => {
	const navigate = useNavigate();
	const [i18n] = useI18n();
	const [open, setOpen] = useSessionStorage('home.onboarding.open', true);

	return open ? (
		<>
			<Card
				actions={[
					{
						icon: XIcon,
						onAction: () => setOpen(false),
					},
				]}
				title={
					<div style={{ textAlign: 'center' }}>
						<DisplayText size='medium' element='h2'>
							{i18n.translate('Title').toUpperCase()}
						</DisplayText>
					</div>
				}
			>
				<Card.Section
					title={
						<Stack alignment='center'>
							<Stack.Item>
								<Icon source={NumberCircleOneIcon} />
							</Stack.Item>
							<Stack.Item>
								<Heading element='h2'>
									{i18n.translate('HTML.Title').toUpperCase()}
								</Heading>
							</Stack.Item>
						</Stack>
					}
				>
					<Stack alignment='center'>
						<Stack.Item fill>
							<TextContainer>
								<p>{i18n.translate('HTML.Subtitle')}</p>
								<List>
									<List.Item>
										{i18n.translate('HTML.Text1')}
									</List.Item>
									<List.Item>
										{i18n.translate('HTML.Text2')}
									</List.Item>
								</List>
							</TextContainer>
						</Stack.Item>
						<Stack.Item>
							<Button
								icon={ArrowRightIcon}
								onClick={() =>
									navigate(`/html${location.search}`)
								}
								accessibilityLabel={i18n.translate(
									'Common.HtmlSitemap'
								)}
							></Button>
						</Stack.Item>
					</Stack>
				</Card.Section>
				<Card.Section
					title={
						<Stack alignment='center'>
							<Stack.Item>
								<Icon source={NumberCircleTwoIcon} />
							</Stack.Item>
							<Stack.Item>
								<Heading element='h2'>
									{i18n.translate('XML.Title').toUpperCase()}
								</Heading>
							</Stack.Item>
						</Stack>
					}
				>
					<Stack alignment='center'>
						<Stack.Item fill>
							<TextContainer>
								<p>{i18n.translate('XML.Subtitle')}</p>
								<List>
									<List.Item>
										{i18n.translate('XML.Text1')}
									</List.Item>
									<List.Item>
										{i18n.translate('XML.Text2')}
									</List.Item>
								</List>
							</TextContainer>
						</Stack.Item>
						<Stack.Item>
							<Button
								icon={ArrowRightIcon}
								onClick={() =>
									navigate(`/xml${location.search}`)
								}
								accessibilityLabel={i18n.translate(
									'Common.XmlSitemap'
								)}
							></Button>
						</Stack.Item>
					</Stack>
				</Card.Section>
				<Card.Section
					title={
						<Stack alignment='center'>
							<Stack.Item>
								<Icon source={NumberCircleThreeIcon} />
							</Stack.Item>
							<Stack.Item>
								<Heading element='h2'>
									{i18n.translate('SEO.Title').toUpperCase()}
								</Heading>
							</Stack.Item>
						</Stack>
					}
				>
					<Stack alignment='center'>
						<Stack.Item fill>
							<TextContainer>
								<p>{i18n.translate('SEO.Subtitle')}</p>
								<p>{i18n.translate('SEO.Text1')}</p>
							</TextContainer>
						</Stack.Item>
						<Stack.Item>
							<Button
								icon={ArrowRightIcon}
								onClick={() =>
									navigate(`/seo${location.search}`)
								}
								accessibilityLabel={i18n.translate(
									'Main.SeoTool.plural'
								)}
							></Button>
						</Stack.Item>
					</Stack>
				</Card.Section>
			</Card>
		</>
	) : null;
};

export default OnboardingSection;
